import AdminTenantsPage from "@/pages/admin/AdminTenantsPage";
import { Building2 } from "lucide-react";

export default function Organizations() {
  return (
    <AdminTenantsPage
      portal="ORGANIZATION"
      title="Organizations"
      subtitle="Approve, suspend, reactivate, assign plans, impersonate, export or delete any Organization tenant."
      entityLabel="Organization"
      Icon={Building2}
      testId="admin-organizations"
      rowTestPrefix="org"
    />
  );
}
